import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-serv-table',
  templateUrl: './serv-table.component.html',
  styleUrls: ['./serv-table.component.css']
})
export class ServTableComponent implements OnInit {

  model = { 'table_name': 'serv_table', 'serv_table_id': '0', 'table_number': '', 'chair_count': '', 
    'hall_name': '', 'hall_name_en': '', 'comment': '' };

  Success_Msg; Error_Msg; Table_No_Msg; Chair_Count_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<ServTableComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Table_No_Msg').subscribe((res: string) => {
      this.Table_No_Msg = res;
    });

    translate.get('Chair_Count_Msg').subscribe((res: string) => {
      this.Chair_Count_Msg = res;
    });
  }

  ngOnInit() {
    if (this.dialog_data != null)
      this.model = this.dialog_data;
  }

  add() {
    if (this.model['table_number'] == '') {
      alert(this.Table_No_Msg);
      return;
    }

    if (this.model['chair_count'] == '') {
      alert(this.Chair_Count_Msg);
      return;
    }

    let values = [];
    values.push(this.model);

    let obj;
    if (this.model['serv_table_id'] == '0')
      obj = { cmd: 'add', values: values };
    else {
      let where = [{ 'serv_table_id': this.model['serv_table_id'] }];
      obj = { cmd: 'update', values: values, where: where };
    }
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') {
          alert(this.Success_Msg);
          // this.dialog_data = {
          //   'status': data.status['type']
          // };
          this.dialog_data = { 'op_type': 'success' };
          this.dialogRef.close(this.dialog_data);
        }
        else {
          alert(this.Error_Msg);
        }
      });
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
